import React from 'react'
import style from './MasProductos.module.css'

import imagen5 from '../../../../utils/images/box-5.png'
import imagen6 from '../../../../utils/images/box-6.png'
import CardProductos from '../../../generales/CardProductos'

const MasProductos = ({ t }) => {

  return (
    <div className={style.container}>
      <p className={style.titulo}>{t('Products.SyncFlow.More-products.title')}</p>
      <div className={style.productos}>
        <CardProductos
          imagen={imagen5}
          link={"/productos/interactive-voice-response"}
          title={"HomePage.Products.interactive-voice-response"}
          text={"HomePage.Products.description-of-interactive-voice-response"}
        />
        <CardProductos
            imagen={imagen6}
            link={"/productos/geontracker"}
            title={"HomePage.Products.geontracker"}
            text={"HomePage.Products.description-of-geontracker"}
        />
      </div>
    </div>
  )
}

export default MasProductos